import { useLanguage } from "../context/LanguageContext";

export const About = () => {
  const { t } = useLanguage();
  
  return (
    <section
      id="opis"
      className="py-16 md:py-24 bg-[#FAFAF9]"
      data-testid="about-section"
    >
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-sm font-medium tracking-wide uppercase text-[#D4A373] mb-3 block">
            {t.about.subtitle}
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold font-['Outfit'] tracking-tight text-[#0F172A] mb-6"
            data-testid="about-title"
          >
            {t.about.title}
          </h2>
          <p className="text-base md:text-lg text-[#64748b] max-w-3xl mx-auto leading-relaxed">
            {t.about.description}
          </p>
        </div>
      </div>
    </section>
  );
};
